import { useLazyQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect, useMemo } from 'react';

import { GetPatientDocument } from '~/graphql/generated/graphql';
import { samePatientModalState } from '~/state/patient/atoms';

export const useFetchPatient = () => {
  const { patientId } = useAtomValue(samePatientModalState);

  const [getPatient, { data, loading }] = useLazyQuery(GetPatientDocument);

  const patient = useMemo(() => {
    const _patient = data?.node?.__typename === 'Patient' ? data.node : undefined;

    return _patient;
  }, [data?.node]);

  useEffect(() => {
    if (patientId) {
      getPatient({
        variables: {
          id: patientId,
        },
      });
    }
  }, [getPatient, patientId]);

  return { patient, loading };
};
